// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
window.Turbo = Turbo
import "./controllers"
